__turbopack_context__.v({
  "sdg": "summary-data-grid-module-scss-module__3Vc4uq__sdg",
  "sdg-cont": "summary-data-grid-module-scss-module__3Vc4uq__sdg-cont",
  "sdg-header": "summary-data-grid-module-scss-module__3Vc4uq__sdg-header",
  "sdg-header-item": "summary-data-grid-module-scss-module__3Vc4uq__sdg-header-item",
  "sdg-header-item-large": "summary-data-grid-module-scss-module__3Vc4uq__sdg-header-item-large",
  "sdg-header-item-sub-heading": "summary-data-grid-module-scss-module__3Vc4uq__sdg-header-item-sub-heading",
  "sdg-row-item": "summary-data-grid-module-scss-module__3Vc4uq__sdg-row-item",
  "sdg-row-item-elem": "summary-data-grid-module-scss-module__3Vc4uq__sdg-row-item-elem",
  "sdg-row-item-elem-background": "summary-data-grid-module-scss-module__3Vc4uq__sdg-row-item-elem-background",
  "sdg-small": "summary-data-grid-module-scss-module__3Vc4uq__sdg-small",
});
